export default [
  {
    path: '/jobs',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'obs-list' */ '@/views/jobs/List')
  },
  {
    path: '/jobs/:id',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'jobs' */ '@/views/jobs/Job')
  }
]
